<template>
    <defaultSec :title="'知识库'">
        <keep-alive>
            <div style="display: flex;justify-content: space-between;align-items: center">
                <el-form :inline="true" :model="formParam" class="demo-form-inline select-wrap" size="mini">
                    <el-form-item label="平台类型">
                        <el-radio-group @change="changePlatformType" v-model="formParam.platformType">
                            <el-radio-button label="coze"></el-radio-button>
                            <el-radio-button label="dify"></el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
        </keep-alive>
        <tablePagination :total="total" :pageSize="formParam.pageSize" @handlePage="handlePage">
            <el-table v-loading="loading" :data="dataList" border size="mini">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column label="知识库名称" prop="name"></el-table-column>
                <el-table-column label="描述" prop="description"></el-table-column>
                <el-table-column label="文档数量">
                    <template slot-scope="scope">
                        {{scope.row.documents.total||scope.row.documents.length||0}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="80">
                    <template slot-scope="scope">
                            <el-button type="success " size="mini" plain
                                       @click="()=>handleOpenDocument(scope.row)">查看
                            </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </tablePagination>
        <el-drawer
            size="80%"
            title="知识库文档"
            :visible.sync="docBoxVisible">
            <div style="padding: 0 20px">
                <div style="margin-bottom: 20px">
                    <el-upload
                        class="upload-demo"
                        :action="''"
                        :show-file-list="false"
                        :httpRequest="(file)=>uploadFile(file,{})">
                        <el-button icon="el-icon-paperclip" size="small" type="danger">上传文件</el-button>
                    </el-upload>
                </div>
                <tablePagination :total="currentKnowledge.documents.total" :pageSize="formParam.pageSize" @handlePage="handlePage">
                    <el-table v-loading="loading" :data="currentKnowledge.documents.data" border size="mini">
                        <el-table-column type="index" label="序号" width="50"></el-table-column>
                        <el-table-column label="文档名称" prop="name"></el-table-column>
                        <el-table-column label="更新(创建)时间" width="150">
                            <template slot-scope="scope">
                                {{new Date((scope.row.update_time||scope.row.created_at)*1000).Format("yyyy-MM-dd hh:mm:ss")}}
                            </template>
                        </el-table-column>
                        <el-table-column label="分段数" prop="slice_count"></el-table-column>
                        <el-table-column label="大小(字节)">
                            <template slot-scope="scope">
                                {{scope.row.size||scope.row.word_count}}
                            </template>
                        </el-table-column>
                        <el-table-column label="召回次数" prop="hit_count"></el-table-column>
                        <el-table-column label="操作" fixed="right" width="240">
                            <template slot-scope="scope">
                                    <el-upload
                                        style="display: inline-block;margin-right: 10px"
                                        :action="''"
                                        :show-file-list="false"
                                        :httpRequest="(file)=>uploadFile(file,scope.row)">
                                        <el-button plain  size="mini" type="warning">重新上传</el-button>
                                    </el-upload>
                                    <el-button type="success " size="mini" plain
                                               @click="()=>handleOpenDocument(scope.row)">查看
                                    </el-button>
                                    <el-button type="danger " size="mini" plain
                                               @click="deleteFile(scope.row)">删除
                                    </el-button>

                            </template>
                        </el-table-column>
                    </el-table>
                </tablePagination>

            </div>
        </el-drawer>
    </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    import tablePagination from '@c/tablePagination'
    export default {
        data() {
            return {
                formParam: {
                    pageSize: 15,
                    currentPage: 1,
                    platformType: 'coze',
                },
                dataList: [],
                propertyTypeList:[],
                propertyClassList:[],
                propertyList:[],
                total: 0,
                loading: false,
                docBoxVisible:false,
                currentKnowledge:{
                    documents: {
                        total:0,
                        data:[]
                    },
                    id:''
                }
            }
        },
        components: {
            defaultSec, tablePagination
        },
        mounted(){
            this.initList()
        },
        methods: {
            initList() {
                this.loading = true
                this.dataList=[]
                this.$apiGet('lechun-ai/knowledge/getList', {  ...this.formParam}).then(res => {
                    this.loading = false
                    this.total = res.total_count||res.total
                    this.dataList = res.dataset_list||res.data
                })
            },
            changePlatformType(){
                this.formParam.currentPage = 1;
                this.initList()
            },
            handlePage(page){
                this.formParam.currentPage = page;
                this.initList()
            },
            handleOpenDocument(row){
                console.log(123,row)
                this.$router.push({
                    name:'aiKnowledgeDetail',
                    params:{id:row.dataset_id||row.id||''},
                    query:{
                        platformType:this.formParam.platformType
                    }
                })
                // this.docBoxVisible = true
                // this.currentKnowledge = {
                //     documents:{
                //         total:row.documents.total||row.documents.length,
                //         data:row.documents.data||row.documents
                //     },
                //     id:row.dataset_id||row.id||'',
                //
                // }
            },
            deleteFile(row){
                this.$confirm('删除后不可撤销，确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$apiGet('lechun-ai/knowledge/delete', {
                        documentId:row.document_id||row.id||'',
                        datasetId: this.currentKnowledge.id||'',
                        platformType:this.formParam.platformType
                    }).then(res => {
                        console.log(res)
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.docBoxVisible = false
                        this.initList()
                    })
                }).catch(() => {

                });
            },
            uploadFile(file,row) {
                console.log(234,file,this.currentKnowledge,row)
                let fileForm = new FormData();
                fileForm.append('file',file.file)
                fileForm.append('datasetId',this.currentKnowledge.id||'')
                fileForm.append('documentId',row.document_id||row.id||'')
                fileForm.append('platformType',this.formParam.platformType)
                this.$apiUpload('lechun-ai/knowledge/save',fileForm).then(res => {
                    console.log(1212,res)
                    if(res.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.docBoxVisible = false
                        this.initList()
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        });
                    }



                })
            },
        }
    }
</script>


<style scoped>
    .expand-title {
        width: 70px;
        color: #444548;
        line-height: 30px;
        text-align: right;
        margin-right: 10px;
        font-weight: 600;
    }

    .expand-flex {
        justify-content: flex-start;
        align-items: center;
        align-content: center;
    }
</style>